import { FC } from 'react';
import styled from 'styled-components';
import { nameof } from '../../utils/stringUtils';
import ExpanderButton from './ExpanderButton';

const Container = styled.div`
  font-size: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  :hover {
    color: ${p => p.theme.palette.themePrimary}
  }
`;

const Text = styled.span`
  margin-right: 0.5rem;
  user-select: none;
`;

interface IProps {
  isExpanded: boolean;
  onClick(): void;
}

const ExpandToggle: FC<IProps> = ({ isExpanded, onClick }) => (
  <Container onClick={onClick}>
    <Text>{isExpanded ? 'Show less' : 'Show more'}</Text>
    <ExpanderButton direction="left" isExpanded={isExpanded} />
  </Container>
);

ExpandToggle.displayName = nameof({ ExpandToggle });
export default ExpandToggle;